<template>
    <ModalBox :is-active.sync="_isActive">
        <template #header>
            <h5
                class="title is-5 has-text-centered"
                style="width: 100%">
                Spring race
            </h5>
        </template>

        <div>
            <p class="has-text-centered mb-4">
                {{ $t('common.rating.banner.modal.info.subtitle') }}
            </p>

            <p
                v-html="$t('common.rating.banner.modal.info.motivation')"
                class="mb-4">
            </p>

            <CompetitionRatingMiniBanner></CompetitionRatingMiniBanner>

            <h3 class="has-text-weight-bold mt-5 mb-3">
                {{ $t("common.rating.banner.modal.info.conditions.title") }}
            </h3>
            <p class="mt-3 mb-3">
                {{ $t("common.rating.banner.modal.info.conditions.subtitle") }}
            </p>

            <div
                :key="idx"
                v-for="(item, idx) in typePoints">
                <InlineSvg
                    :class="['mr-2', `fill-${ tagCapColor(item.point) }`]"
                    :src="solarCup"
                    alt="solarCup">
                </InlineSvg>
                {{ item.point }}
                {{ `${ $t(`admin.offer.competitionBanner.${ item.point === 1 ? 'point' : 'points' }`) }:` }}
                {{ item.content }}
            </div>

            <p class="mt-3">
                {{ $t("common.rating.banner.modal.info.conditions.info.first") }}
            </p>

            <p class="mt-3">
                {{ $t("common.rating.banner.modal.info.conditions.info.two") }}
            </p>
            <p
                v-html="$t('common.rating.banner.modal.info.conditions.info.three')"
                class="mt-3">
            </p>

            <h3 class="has-text-weight-bold mt-5 mb-3">
                {{ $t("common.rating.banner.modal.info.carrying.title") }}
            </h3>
            <p class="mt-4">
                {{ $t("common.rating.banner.modal.info.carrying.content") }}
            </p>

            <h3 class="has-text-weight-bold mt-5 mb-3">
                {{ $t("common.rating.banner.modal.info.top.title") }}
            </h3>
            <p
                :key="idx"
                v-for="(_, idx) in new Array(20)"
                class="mt-2">
                {{ $t(`common.rating.banner.modal.info.top.${ idx + 1 }`) }}
            </p>

            <p class="mt-4">
                <i18n
                    path="common.rating.banner.modal.info.description.first.text"
                    tag="span">
                    <template #link>
                        <router-link
                            target="_blank"
                            :to="{
                                name: 'webmaster:statistics:statistics',
                                query: { backLink: $route.fullPath }
                            }">
                            <span class="has-link">
                                {{ $t("common.rating.banner.modal.info.description.first.statistic") }}
                            </span>
                        </router-link>
                    </template>
                </i18n>
            </p>

            <p
                v-html="$t('common.rating.banner.modal.info.description.second')"
                class="mt-4">
            </p>

            <p
                v-html="$t('common.rating.banner.modal.info.footer')"
                class="mt-4">
            </p>
        </div>

        <template #footer>
            <router-link
                :to="{
                    name: routerLink,
                    query: { 
                        backLink: $route.fullPath,
                        filters: encodeFilters({ inCompetition: true }),
                    }
                }">
                <b-button class="is-fullwidth is-info is-light">
                    {{ $t(`common.rating.banner.modal.footer`) }}
                </b-button>
            </router-link>
        </template>
    </ModalBox>
</template>

<script>
  import CompetitionRatingMiniBanner from "@/components/Common/Competition/CompetitionRatingMiniBanner.vue";
  import ModalBox from "@/components/Common/Modals/ModalBox.vue";
  import { mapGetters } from "vuex";
  import InlineSvg from "vue-inline-svg";
  import { encodeFilters } from "@core/filters";

  export default {
    name: "CompetitionRatingInfoModal",
    components: { InlineSvg, CompetitionRatingMiniBanner, ModalBox },

    props: {
      isActive: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters(["role"]),

      _isActive: {
        get () {
          return this.isActive;
        },
        set (value) {
          this.$emit("update:isActive", value);
        }
      },

      routerLink () {
        return this.role === "webmaster" ? "webmaster:offers" : "admin:offers:offers";
      },

      solarCup () {
        return require("@/assets/Competition/solar_cup-bold.svg");
      },

      typePoints () {
        return [
          { point: 3, content: "TZ, MA, ЕС, CR" },
          { point: 2, content: "IQ, CI, CO, NG, PE, HN, NP, GT, DO" },
          { point: 1, content: "МХ, SV, BO, ZA, IN, UG, RU, KZ" }
        ];
      }
    },

    methods: {
      encodeFilters,
      tagCapColor (value) {
        return { 1: "warning", 2: "info", 3: "success" }[value];
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .animation-content {
      width: 100%;
      max-width: 650px !important;

      .modal-card {
        width: 100%;
        max-width: none;
      }
    }

    .fill-info path {
      fill: $info;
    }
    .fill-success path {
      fill: $success;
    }
    .fill-warning path {
      fill: $primary;
    }
  }
</style>